export const SEO_DEFAULTS = {
  siteName: 'BrandPartners',
  domain: 'https://bp.agency',
  defaultImage: 'https://bp.agency/og-square.png',
};

export const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Why Us', to: '/why-us' },
  { label: 'Services', to: '/services' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'Articles', to: '/articles' },
  { label: 'Contact', to: '/contact' },
];

export const CONTACT_INFO = {
  phone: '954-745-9545',
  phoneTel: '+19547459545',
  email: 'hello@bp.agency',
  addressLines: ['1790 Hwy A1A, Suite 209', 'Satellite Beach, FL 32937'],
  social: {
    linkedin: 'https://www.linkedin.com/company/416826',
    facebook: 'https://www.facebook.com/ourbrandpartners/',
  },
};

export const HEADLINE_STATS = [
  { value: '19', suffix: '', label: 'Years partnering with brands' },
  { value: '1,000', suffix: '+', label: 'Websites built and launched' },
  { value: '1B', suffix: '+', label: 'Ads served for clients' },
  { value: '500K', suffix: '+', label: 'Qualified leads delivered' },
];

export const PARTNERSHIP_PILLARS = [
  {
    icon: 'handshake',
    color: 'blue',
    title: 'Partners, not vendors',
    body:
      'We work as a direct extension of your team - same Slack, same calls, same goals. You get strategists, designers, and marketers who actually know your business.',
  },
  {
    icon: 'target',
    color: 'teal',
    title: 'Results you can see',
    body:
      'Real-time dashboards, transparent reporting, and metrics that matter - leads, revenue, ROI. No vanity charts, no jargon, no surprises.',
  },
  {
    icon: 'heart',
    color: 'coral',
    title: 'Built for every business',
    body:
      'From the family-owned shop on Main Street to multi-location enterprises - same care, same craft, same outcome focus. We earn your business every month.',
  },
];

export const SERVICE_TABS = [
  {
    key: 'marketing',
    title: 'Marketing',
    blurb: 'Grow visibility and pipeline with search, paid, and social - all measured in revenue.',
    items: [
      { name: 'Search Engine Optimization (SEO)', desc: 'Local & national SEO that compounds month over month.' },
      { name: 'AI Optimization (AEO)', desc: 'Be the cited answer in ChatGPT, Gemini, and Perplexity.' },
      { name: 'Pay-Per-Click (PPC)', desc: 'Google Ads, LSAs, and paid social tuned for ROI.' },
      { name: 'Social Media Marketing', desc: 'Content, engagement, and paid across Meta, IG, LinkedIn.' },
      { name: 'Email & CRM Marketing', desc: 'Automated nurture flows that convert leads to revenue.' },
      { name: 'Reputation Management', desc: 'Review generation and brand trust at scale.' },
    ],
  },
  {
    key: 'web',
    title: 'Web & Tech',
    blurb: 'Conversion-grade websites and the engineering behind them.',
    items: [
      { name: 'Website Design & Redesign', desc: 'Built to load fast, rank, and convert.' },
      { name: 'WordPress Development', desc: 'Custom, scalable, easy to manage.' },
      { name: 'eCommerce Development', desc: 'Optimized PDPs, checkout, and integrations.' },
      { name: 'Custom Programming', desc: 'CRMs, APIs, dashboards, and automation.' },
      { name: 'Hosting & Email', desc: 'Secure, fast, monitored, and managed.' },
      { name: 'Managed IT Services', desc: 'Infrastructure, security, and cloud.' },
    ],
  },
  {
    key: 'creative',
    title: 'Creative',
    blurb: 'The visual identity and content engine that makes your brand memorable.',
    items: [
      { name: 'Photography & Videography', desc: 'Lifestyle, branding, and before/after content.' },
      { name: 'Video Creation & Editing', desc: 'Promo, testimonial, and ad creative.' },
      { name: 'Graphic Design', desc: 'Ads, social graphics, and marketing assets.' },
      { name: 'Logo & Branding', desc: 'Complete identity systems and positioning.' },
      { name: 'Voiceover', desc: 'Professional voice for ads and branded content.' },
      { name: 'Print & Collateral', desc: 'Cards, flyers, brochures, direct mail.' },
    ],
  },
  {
    key: 'growth',
    title: 'Growth',
    blurb: 'The consulting, experimentation, and analytics that compound the rest.',
    items: [
      { name: 'Growth Hacking', desc: 'Funnel experiments and rapid scaling.' },
      { name: 'Business Consulting', desc: 'Marketing strategy and KPI architecture.' },
      { name: 'Analytics & Reporting', desc: 'Real-time dashboards and attribution.' },
      { name: 'Competitor Marketing', desc: 'Targeted positioning vs. category leaders.' },
      { name: 'Remarketing Programs', desc: 'Recapture qualified intent at lower CPA.' },
      { name: 'Media Buying', desc: 'Digital, OTT/CTV, and traditional placement.' },
    ],
  },
];

export const AUDIENCE_TIERS = [
  {
    badge: 'For Local Heroes',
    color: 'amber',
    title: 'Local & family-owned',
    line: 'Roofers, pool builders, clinics, restaurants, attorneys.',
    body:
      'You don\'t need an enterprise contract - you need leads, a phone that rings, and a website that earns trust. We start with a free audit and grow with you.',
    highlights: ['Google Business Profile', 'Local SEO + LSAs', 'Conversion website', 'Monthly reporting'],
  },
  {
    badge: 'For Growing Brands',
    color: 'blue',
    title: 'Regional & multi-location',
    line: '5–50 locations, growing teams, ambitious goals.',
    body:
      'You\'ve outgrown DIY but you\'re not ready for a six-figure retainer agency. We give you a senior team, real strategy, and the operational rigor to scale.',
    highlights: ['Multi-location SEO', 'Paid acquisition at scale', 'Web platforms', 'Attribution & CRO'],
  },
  {
    badge: 'For Enterprise',
    color: 'teal',
    title: 'Established & enterprise',
    line: 'Mid-market and enterprise brands with complex stacks.',
    body:
      'You need a partner who can move quickly, integrate with your existing teams, and deliver senior craft across web, paid, and AI search - all in one room.',
    highlights: ['Custom engagements', 'Senior strategists', 'Engineering depth', 'Executive reporting'],
  },
];

export const PROCESS_STEPS = [
  { n: '01', title: 'Free Analysis', body: 'A no-cost audit of your marketing, your competitors, and your opportunity. Zero obligation.' },
  { n: '02', title: 'Custom Strategy', body: 'A tailored plan aligned to your goals, budget, and category - written in plain English.' },
  { n: '03', title: 'Execute & Report', body: 'We ship - design, dev, ads, content - with full real-time visibility in your dashboard.' },
  { n: '04', title: 'Optimize & Scale', body: 'Continuous experimentation. We scale what works, kill what doesn\'t, compound the rest.' },
];

export const CLIENT_BRANDS = [
  'Cody Pools',
  'Neal Communities',
  'Clear Choice Windows',
  'Relievus',
  'American Pools',
  'Disney',
  'Ford',
  'Coldwell Banker',
];

export const TESTIMONIALS = [
  { quote: 'Brand Partners has been a key part of our historic growth for nearly a decade. Their team works as an extension of ours - aligned at every step, bolstered through constant communication, responsiveness, and results.', author: 'Vincent Servantez', role: 'President, Cody Pools Florida', rating: 5 },
  { quote: 'We have used Brand Partners for approx 10 years. Ed is very professional, responsive, prompt, personable, and always takes the extra step. No matter how rapidly the Group has grown, no challenge is too small.', author: 'Jill Rafilovich', role: 'Client since 2014', rating: 5 },
  { quote: 'This company will not disappoint you. They really care about delivering high-end services to the satisfaction of their clients at a very competitive price. You can tell they genuinely care about your business.', author: 'David Adelstein', role: 'Attorney at Law', rating: 5 },
  { quote: 'Great customer service! Extremely professional and dedicated to our needs. Under maintenance and management with Ed and his team for 10 years - could not be more satisfied.', author: 'Greg Wheble', role: 'Business Owner', rating: 5 },
];

export const RESULT_CASES = [
  {
    n: '01',
    client: 'Cody Pools Florida',
    category: 'Home Services · Multi-location',
    headline: 'Nearly a decade of compounding lead growth for the world\'s largest pool builder.',
    metric: '+312%',
    metricLabel: 'YoY Qualified Leads',
    services: ['SEO', 'PPC', 'Web', 'Local'],
    color: 'blue',
  },
  {
    n: '02',
    client: 'Neal Communities',
    category: 'Real Estate · Builder',
    headline: 'Full-funnel campaigns for one of Florida\'s premier home builders.',
    metric: '14M+',
    metricLabel: 'Targeted Impressions',
    services: ['Web', 'Display', 'CRM'],
    color: 'teal',
  },
  {
    n: '03',
    client: 'Clear Choice Windows',
    category: 'Home Services · Local',
    headline: 'Local SEO and LSAs that doubled showroom appointments in six months.',
    metric: '2.1×',
    metricLabel: 'Showroom Appointments',
    services: ['Local SEO', 'LSA', 'Web'],
    color: 'amber',
  },
  {
    n: '04',
    client: 'Relievus',
    category: 'Healthcare · Multi-clinic',
    headline: 'Patient acquisition across 8 clinics - HIPAA-aware, performance-grade.',
    metric: '−38%',
    metricLabel: 'Cost Per Patient',
    services: ['SEO', 'Paid', 'Web'],
    color: 'coral',
  },
];

export const ARTICLES = [
  {
    slug: 'ai-search-aeo-playbook',
    kind: 'Playbook',
    minutes: 6,
    title: 'The 2026 AEO Playbook: Winning ChatGPT, Gemini & Perplexity Visibility',
    excerpt: 'AI assistants now mediate 40%+ of high-intent queries. Here\'s the structured-content framework we use to make our clients the cited answer.',
    img: '/images/blog/photo-1677442136019-21780ecad995.jpg',
  },
  {
    slug: 'core-web-vitals-conversion',
    kind: 'Insight',
    minutes: 4,
    title: 'Core Web Vitals Are a Conversion Lever, Not a Tax',
    excerpt: 'A 0.5s LCP improvement lifted lead-form completion 11% across a portfolio of 27 client sites. Here\'s our engineering checklist.',
    img: '/images/blog/photo-1551288049-bebda4e38f71.jpg',
  },
  {
    slug: 'local-seo-multi-location',
    kind: 'Field Notes',
    minutes: 5,
    title: 'Multi-Location Local SEO: A Playbook From 200+ GBPs',
    excerpt: 'Citation strategy, review velocity, and the entity model we use when a brand opens its tenth, twentieth, or hundredth location.',
    img: '/images/blog/photo-1542744173-8e7e53415bb0.jpg',
  },
];
